import React, { useState, useEffect } from 'react';
import { Card, CardBody, Container, Form } from 'reactstrap';
import { Row, Col, Button } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { useLocation, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import { initialValues } from './constants/initialValues';
import { useFormData, validationForSelectedOrder } from './constants/Formdata';
import { useDeviceData } from './constants/UnassignedDevice';
import { PAGE_TITLES } from '../Common/constants';
import { handleFormSubmit } from './constants/OrderListingFunctions';
import { Loader } from '../Utils/Loader';
import { SelectOrderDetails } from './SelectOrderDetails';
import { SubscriptionDetails } from './SubscriptionDetail';
import { DateAndAttributeDetails } from './DateAndAttributeDetails';
import { useDispatch, useSelector } from 'react-redux';
import ResourceOverrideCard from './ResourceOverride';
import { ProvisingAttributesDetails } from './ProvisioningAttributesDetails';
function SelectedOrders() {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { selectedOffer } = location.state || {};
    const{subscriptionId}=location.state || '';
    const [startDate, setStartDate] = useState()
    const { formData, setFormData } = useFormData();
    const idArray = useDeviceData(setLoading);
    const operatorConfiguration = useSelector((state)=>state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration)
    const prefix = operatorConfiguration?.configurations?.Prefixes?.value?.OrderPrefix?.value
    const sequence = operatorConfiguration?.configurations?.SequenceHandling?.value?.OrderSequence?.value
    const id = prefix && prefix + 'X'.repeat(sequence?.length)

    const isEIPEnabled = operatorConfiguration?.configurations?.EIP?.value?.Enabled?.value === true;


    const operatorId = localStorage.getItem('operatorId');

    const customerListTitle = isEIPEnabled
        ? PAGE_TITLES.CUSTOMER_LIST_EIP
        : PAGE_TITLES.CUSTOMER_LIST;
    const [resourceOverrides, setResourceOverrides] = useState([{ resourceName: null, value: '' }]);
    const [resourceOptions, setResourceOptions] = useState([]);

    useEffect(() => {
        if (selectedOffer) {
            const grants = (selectedOffer?.Grants || [])
                .filter(grant => grant.overridable === true)
                .map(grant => grant.resourceName);

            const charges = (selectedOffer?.Charges || [])
                .filter(charge => charge.overridable === true)
                .map(charge => charge.resourceName);

            setResourceOptions([...grants, ...charges]);
        }
    }, [selectedOffer]);

    const handleResourceOverridesChange = (updatedOverrides) => {
        setResourceOverrides(updatedOverrides);
    };

    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white'>
                <Formik initialValues={initialValues} validationSchema={validationForSelectedOrder(subscriptionId, id)} onSubmit={(values) => handleFormSubmit(values, selectedOffer, formData, navigate, subscriptionId, dispatch, resourceOverrides)} >
                    {({ handleChange, handleSubmit, values, touched, setFieldTouched, setFieldValue, errors }) => (
                        <Form className="needs-validation" onSubmit={handleSubmit}>
                            <Container fluid>
                                {loading && (<Loader />)}
                                <BreadCrumb title={PAGE_TITLES.CUSTOMER_SUBSCRIBE} pageTitle={customerListTitle} />

                                <h5 className="fs-16 fw-semi-bold text-black mb-3">Subscription Details</h5>
                                <SelectOrderDetails selectedOffer={selectedOffer} />

                                <div class="my-3">
                                    <div className="border border-1 rounded-1 p-3">
                                        <Row className='mb-3'>
                                            <SubscriptionDetails values={values} setFieldValue={setFieldValue} touched={touched} errors={errors} handleChange={handleChange} idArray={idArray} subscriptionId={subscriptionId} id={id} />
                                            <DateAndAttributeDetails values={values} selectedOffer={selectedOffer} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} setFormData={setFormData} setStartDate={setStartDate} initialValues={initialValues} startDate={startDate} formData={formData} />
                                        </Row>
                                        <Row className='mb-3'>
                                            <ProvisingAttributesDetails startDate={startDate} selectedOffer={selectedOffer} setFormData={setFormData} formData={formData} />
                                        </Row>
                                        <Row className='mb-3'>
                                            <ResourceOverrideCard
                                                resourceOverrides={resourceOverrides}
                                                setResourceOverrides={handleResourceOverridesChange}
                                                resourceOptions={resourceOptions}
                                            />
                                        </Row>
                                    </div>

                                </div>
                                <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-end gap-2 mt-5">
                                    <div className='d-flex gap-2'>
                                        <button
                                        type="button"
                                        className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                        onClick={() => navigate(`/order-filtering/${selectedOffer?.CustomerId}`)}
                                    >
                                        <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                        <span class="px-2 ms-2 me-1 fw-bold">
                                            Cancel
                                        </span>
                                    </button>

                                    <button
                                        type="submit"
                                        class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                    >
                                        <i class="ri-add-line label-icon align-middle fs-16 me-1"></i>
                                        <span class="px-2 ms-2 me-1 fw-bold">
                                            Add Offer
                                        </span>
                                    </button>
                                    </div>
                                </div>
                            </Container>
                        </Form>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    );
}

export default SelectedOrders;
